export const CALCULATED_FIELD_NAME = 'fromSource';
export const CALCULATED_FIELD_LABEL = 'Profile Data';

// default value for fromSource
export const CALCULATED_DEFAULT_VALUE = { source: 'users', key: '', field: '' };

// empty option for fromSource.key select
export const EMPTY_OPTION = { label: '-- Empty --', value: '' };

export const INMATE_PROFILE_FIELDS = [
  { value: 'member_id',          label: 'Member ID',           type: 'text'   },
  { value: 'booking_id',         label: 'Booking ID',          type: 'text'   },
  { value: 'is_active',          label: 'Is Active',           type: 'switch' },
  { value: 'current_housing',    label: 'Current Housing',     type: 'text'   },
  { value: 'classification',     label: 'Classification',      type: 'text'   },
  { value: 'first_name',         label: 'First Name',          type: 'text'   },
  { value: 'middle_name',        label: 'Middle Name',         type: 'text'   },
  { value: 'last_name',          label: 'Last Name',           type: 'text'   },
  { value: 'alternate_name',     label: 'Alternate Name',      type: 'text'   },
  { value: 'birthday',           label: 'Date of Birth',            type: 'date'   },
  { value: 'gender',             label: 'Gender',              type: 'text'   },
  { value: 'race',               label: 'Race',                type: 'text'   },
  { value: 'ethnicity',          label: 'Ethnicity',           type: 'text'   },
  { value: 'preferred_language', label: 'Preferred Language',  type: 'text'   },
  { value: 'veteran_status',     label: 'Veteran Status',      type: 'text'   },
  { value: 'phone_number',       label: 'Phone Number',        type: 'text'   },
  { value: 'email_address',      label: 'Email Address',       type: 'text'   },
  { value: 'notes',              label: 'Notes',               type: 'text'   },
  { value: 'description',        label: 'Description',         type: 'text'   },
  { value: 'admission_date',     label: 'Admission Date',      type: 'date'   },
];

export const MEMBER_PROFILE_FIELDS = [
  { value: 'member_id',          label: 'Member ID',           type: 'text'   },
  { value: 'member_type',        label: 'Member Type',         type: 'text'   },
  { value: 'is_active',          label: 'Is Active',           type: 'switch' },
  { value: 'employer',           label: 'Employer',            type: 'text'   },
  { value: 'title',              label: 'Title',               type: 'text'   },
  { value: 'first_name',         label: 'First Name',          type: 'text'   },
  { value: 'middle_name',        label: 'Middle Name',         type: 'text'   },
  { value: 'last_name',          label: 'Last Name',           type: 'text'   },
  { value: 'alternate_name',     label: 'Alternate Name',      type: 'text'   },
  { value: 'birthday',           label: 'Date of Birth',            type: 'date'   },
  { value: 'gender',             label: 'Gender',              type: 'text'   },
  { value: 'race',               label: 'Race',                type: 'text'   },
  { value: 'ethnicity',          label: 'Ethnicity',           type: 'text'   },
  { value: 'preferred_language', label: 'Preferred Language',  type: 'text'   },
  { value: 'veteran_status',     label: 'Veteran Status',      type: 'text'   },
  { value: 'phone_number',       label: 'Phone Number',        type: 'text'   },
  { value: 'email_address',      label: 'Email Address',       type: 'text'   },
  { value: 'description',        label: 'Description',         type: 'text'   },
  { value: 'facility_code',      label: 'Facility Code',       type: 'text'   },
];
